/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface BrandProductVariantMovementTags {
  brandEquity?: number;
  brandId?: number;
  brandName?: string;
  defaultImageURL?: string;
  displayOrder?: number;
  expiration?: string;
  externalId?: number;
  internalEAN?: string;
  maxTradesPerPerson?: number;
  productId?: number;
  productName?: string;
  productVariantId?: number;
  productVariantName?: string;
  ratingAverage?: number;
  reviewCount?: number;
  showOnWebSite?: boolean;
  stockCount?: number;
  tradePoints?: number;
  tradeable?: boolean;
  weight?: number;
}
